const Logo = () => <h2>trellzo</h2>;
export default Logo;
